import { Component, OnInit, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { Router } from '@angular/router';
import { CeqTableComponent } from 'src/app/ceq/common/ceq-table/ceq-table.component';
import { EditChildRendered } from '../../../common/renders/edit-child-rendered';
import { DeleteChildRendered } from '../../../common/renders/delete-child-rendered';
import { VehicleconfigService } from '../vehicleconfig.service';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';

@Component({
  selector: 'app-vehicleconfig-list',
  templateUrl: './vehicleconfig-list.component.html',
  styleUrls: ['./vehicleconfig-list.component.scss']
})
export class VehicleconfigListComponent implements OnInit {

  @ViewChild('CeqGrid', { static: false }) ceqGrid: CeqTableComponent;
  
  options: GridOptions;
  PageSizes = [10, 25, 50, 100, 1000];
  pageSize = 10;

  gridOptions = {
    context: this,
    frameworkComponents: {
      childEditRenderer: EditChildRendered,
      childDeleteMessageRenderer: DeleteChildRendered
    },
    suppressHorizontalScroll: true,
    onRowDoubleClicked: (params: any) => this.edit(params),
    icons: {
      sortAscending: '<i class="fa fa-sort-up" style="margin-left:10px"></i>',
      sortDescending: '<i class="fa fa-sort-down" style="margin-left:10px"></i>',
      sortUnSort: '<i class="fa fa-sort" style="margin-left:10px"></i>'
    }
  };

  columnDefs = [
    {
      headerName: 'Código',
      field: 'VehicleKey',
      flex: 1,
      sortable: true,
      resizable: true,
    },
    {
      headerName: 'Descripción',
      field: 'VehicleDescription',
      flex: 3,
      sortable: true,
      resizable: true,
    },
    {
      headerName: 'Editar',
      width: 90,
      cellRenderer: 'childEditRenderer',
      cellClass: 'text-center',
    },
    {
      headerName: 'Eliminar',
      width: 90,
      cellRenderer: 'childDeleteMessageRenderer',
      cellClass: 'text-center',
    }
  ];

  constructor(
    private router: Router,
    private globalFunctionService: GlobalFunctionsService,
    private vehicleConfigService: VehicleconfigService
  ) { }

  ngOnInit(): void { }

  async gridEmiter(GridOptions: GridOptions) {
    this.options = GridOptions;
    await this.getVehicleConfig();
  }

  async refresh(){
    await this.getVehicleConfig();
  }

  async onPageSizeChange(value: any) {
    this.pageSize = Number(value);
    await this.getVehicleConfig();
  }

  async getVehicleConfig() {
    this.ceqGrid.showLoading();
    await this.vehicleConfigService.getVehicleConfigList().toPromise().then(async data => {
        // Asumiendo que el componente ceq-table maneja la propiedad .data
        this.ceqGrid.data = data;
        this.ceqGrid.hidenloading();
      }, async (error) => {
        console.log(error);
        this.globalFunctionService.messageBimbo("Error al cargar la configuración vehicular", 'error', '¡Error!');
      }
    );
  }

  btnAddClick() {
    this.router.navigate(['/tax/vehicleconfig/create']);
  }

  edit(row: any) {
    this.router.navigate(['/tax/vehicleconfig', row.data.VehicleKey]);
  }

  async delete(row: any) {
    const confirm = await this.globalFunctionService.messageBimbo(
      `¿Desea eliminar la configuración vehicular ${row.data.VehicleKey}?`, 
      'question1', 
      'Confirmación'
    );

    if (confirm) {
      this.vehicleConfigService.deleteVehicleConfig(row.data.VehicleKey).subscribe({
        next: async () => {
          await this.globalFunctionService.messageBimbo('La configuración se eliminó correctamente.', 'success', '¡Éxito!');
          await this.getVehicleConfig(); // Recargar datos
        },
        error: async (err) => {
          const errorMsg = err.error || 'No se pudo eliminar el registro';
          await this.globalFunctionService.messageBimbo(errorMsg, 'error', '¡Error!');
        }
      });
    }
  }
}